import { emptyValidator, formValidator } from "../../validators";

const agreementTemplateValidationStatus = {
  agtTitle: {
    validators: [emptyValidator()],
    name: "Template Title",
  },
  agtTemplate: {
    validators: [emptyValidator()],
    name: "Template Body",
  },
};

const renderValidationStatus = {
  agtId: {
    validators: [emptyValidator()],
    name: "Template",
  },
  placeholders: {
    validators: [emptyValidator()],
    name: "Placeholders",
  },
};

export const agreementTemplateValidation = (data) => {
  return formValidator(data, agreementTemplateValidationStatus);
};

export const agreementTemplateRenderValidation = ({ agtId, placeholders }) => {
  const errors = formValidator({ agtId, placeholders }, renderValidationStatus);

  if (!errors.placeholders && placeholders) {
    const hasValidEntry = Object.entries(placeholders).some(([key, value]) => {
      return String(key || "").trim() !== "" && String(value || "").trim() !== "";
    });

    if (!hasValidEntry) {
      errors.placeholders = "At least one placeholder key/value is required";
    }
  }

  return errors;
};
